import { Capacitor } from '@capacitor/core'

function getNativeOrigin(): string {
  const env = import.meta.env.VITE_ENV
  const prefix = env === 'staging' ? 'acc.' : env === 'development' ? 'dev.' : ''
  return `https://${prefix}mijnziekenhuis.be`
}

export function buildAwellStatusUrl(status: 'success' | 'cancelled') {
  const origin = Capacitor.isNativePlatform() ? getNativeOrigin() : window.location.origin

  const url = new URL(`${origin}/awell-questionnaire-completion`)

  url.searchParams.set('awellStatus', status)
  return url.toString()
}
